/*
toastTypes.ts
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

export enum ToastType {
Success,
Warning,
Danger,
Info,
None
}
export interface Toast {
    id: number;
    message: string;
    type: ToastType;
    closeButton: boolean;
    timeoutResetCount: number;
    displayImmediately?: boolean;
  }

  
  export type AddToast = (message: string, type: ToastType, closeButton: boolean, displayImmediately?: boolean) => void;
  export type RemoveToast = (id: number) => void;
